import { CONTRAST_ENUM } from "../constants/constants";

export const getFontSizeLabel = (size: string) => {
  switch (size) {
    case "small":
      return "Mažas";
    case "standard":
      return "Standartinis";
    case "large":
      return "Didelis";
    case "very-large":
      return "Labai didelis";
    default:
      return "Standartinis";
  }
};

export const getContrastLabel = (contrastType: CONTRAST_ENUM) => {
  switch (contrastType) {
    case CONTRAST_ENUM.STANDARD:
      return "Standartinis";
    case CONTRAST_ENUM.WHITE:
      return "Baltas";
    case CONTRAST_ENUM.DARK:
      return "Tamsus";
    default:
      return "Standartinis";
  }
};
